'use client';
import { lazy, Suspense, type ComponentProps } from 'react';
export type * from "/tmp/build-327/node_modules/@eliadmin/core/src/pages/(jobportal)/create-job-offer/page.tsx";
type Props = NonNullable<ComponentProps<typeof import("/tmp/build-327/node_modules/@eliadmin/core/src/pages/(jobportal)/create-job-offer/page.tsx").default>>;
const Deferred = lazy(() => import("@eliadmin/route-original/8e5d3f4180f7"));
function DeferredRoute(props: Props) { return <Suspense fallback={null}><Deferred {...props} /></Suspense>; }
export default DeferredRoute;

